<app-sidenav *ngIf="!isRedirectAccess" (onToggleSideNav)="onToogleSideNav($event)"></app-sidenav>
<app-body
[collapsed]="isSideNavCollapsed"
[screenWidth]="screenWidth"
[isRedirectAccess]="isRedirectAccess"
>
</app-body>